import { render, staticRenderFns } from "./GruposGrade.vue?vue&type=template&id=541b279e&scoped=true"
import script from "./GruposGrade.vue?vue&type=script&lang=js"
export * from "./GruposGrade.vue?vue&type=script&lang=js"
import style0 from "./GruposGrade.vue?vue&type=style&index=0&id=541b279e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541b279e",
  null
  
)

export default component.exports